'use client'

import WhatToExpectSection from '@/components/whatToExpect'
import type { Step } from '@/components/whatToExpect'
import {
  UserCheck,
  ClipboardList,
  Stethoscope,
  CalendarCheck,
} from 'lucide-react'
import React from 'react'

const steps: Step[] = [
  {
    icon: UserCheck,
    title: 'Initial History Intake',
    description:
      'Initial History will be taken by a qualified psychologist. This will include the current symptom presentation, family concerns if any, past psychiatric/psychological history and any relevant medical history',
  },
  {
    icon: ClipboardList,
    title: 'Symptom Assessment & Reporting',
    description:
      'You will be given psychometric assessments based on the symptoms you present with. Your psychologist will evaluate your responses and a report will be provided to you.',
  },
  {
    icon: Stethoscope,
    title: 'Psychiatric Consultation',
    description:
      'You will then be introduced to our psychiatrist to determine the most appropriate treatment course.',
  },
  {
    icon: CalendarCheck,
    title: 'Treatment Planning & Scheduling',
    description:
      'An appointment will be scheduled with your therapist as per your therapeutic plan. The frequency of sessions, and duration of treatment will all be discussed in your initial session.',
  },
]

const NavigatingMentalWellness: React.FC = () => (
  <section className="py-20">
    <div className="max-w-6xl mx-auto text-center">
      <div className="relative">
        {/* Abstract background element */}
        <div className="absolute inset-0 flex items-center justify-center opacity-10">
          <div className="w-96 h-96 bg-gradient-to-br from-emerald-200 to-teal-200 rounded-full blur-3xl"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto">
          <h2 className="text-4xl lg:text-5xl font-serif text-gray-900 mb-8">
            Navigating Mental Wellness, Together
          </h2>
          <WhatToExpectSection
            steps={steps}
            mainTitle="Your Evaluation Journey: What to Expect at ReACH"
            mainDescription="We strive to make your evaluation process as comfortable and clear as possible. Here's what you can typically expect:"
          />
        </div>
      </div>
    </div>
  </section>
)

export default NavigatingMentalWellness
